import {
  LocalActionType,
  LocaisStateReducer,
  SET_LOCAIS, LocalTypes,
  SET_LOCAL_DATA_BY_ID,
  SET_LOADING_BY_ID,
  SET_CLEAR_LOCAL_DATA_BY_ID,
  SET_CREATED_LOCAL_SUCCESS,
  SET_LOADING,
  SET_SUCCESS,
} from './types';

const INITIAL_STATE: LocaisStateReducer = {
  localData: null,
  saveSucess: false,
  loadingLocalData: false,
  data: [],
  isError: false,
  error: '',
  loading: false,
  clear: false,
};

const locaisReducer = (state = INITIAL_STATE, action: LocalActionType) => {
  switch (action.type) {
    case LocalTypes.LOCAIS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case LocalTypes.LOCAIS_REQUEST_FAILURE:
      return {
        ...state,
        error: action.payload,
        isError: true,
        loadingLocalData: false,
        loading: false,
      };
    case SET_LOCAL_DATA_BY_ID:
      return {
        ...state,
        localData: action.payload,
      };
    case SET_CLEAR_LOCAL_DATA_BY_ID:
      return {
        ...state,
        localData: null,
      };
    case SET_SUCCESS:
      return {
        ...state,
        success: action.payload,
      };
    case SET_LOADING_BY_ID:
      return {
        ...state,
        loadingLocalData: action.payload,
      };
    case SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case SET_CREATED_LOCAL_SUCCESS:
      return {
        ...state,
        clear: action.payload,
      };
    case SET_LOCAIS:
      return {
        ...state,
        data: action.payload,
        error: '',
        isError: false,
        loading: false,
      };
    default:
      return state;
  }
};
export default locaisReducer;
